(function () {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-head');
    const menu = head.querySelector('.gh-head-menu');
    const nav = menu.querySelector('.nav');
    if (!nav) return;

    const isHome = document.body.classList.contains('home-template');
    if (isHome) {
        // Ghost treats same-page hash links as current navigation items. On the
        // homepage that would underline every planned topic anchor, so reset
        // the generated state and keep only the real homepage entry active.
        nav.querySelectorAll('.nav-current').forEach(function (item) {
            item.classList.remove('nav-current');
        });
        nav.querySelectorAll('[aria-current], [data-primary-nav-active]').forEach(function (link) {
            link.removeAttribute('aria-current');
            link.removeAttribute('data-primary-nav-active');
        });
        const homeLink = Array.from(nav.querySelectorAll('a')).find(function (link) {
            try {
                const url = new URL(link.href, window.location.origin);
                return url.origin === window.location.origin && url.pathname === '/' && !url.hash;
            } catch (error) {
                return false;
            }
        });
        if (homeLink) {
            homeLink.parentElement.classList.add('nav-current');
            homeLink.setAttribute('aria-current', 'page');
        }
    }

    const primaryTag = document.querySelector('[data-primary-tag]')?.dataset.primaryTag;
    if (primaryTag) {
        const tagPath = '/tag/' + primaryTag + '/';
        nav.querySelectorAll('a').forEach(function (link) {
            try {
                if (new URL(link.href, window.location.origin).pathname === tagPath) {
                    link.parentElement.classList.add('nav-current');
                    link.setAttribute('aria-current', 'page');
                    link.setAttribute('data-primary-nav-active', 'true');
                }
            } catch (error) {
                // Ignore malformed third-party navigation URLs.
            }
        });
    }

    nav.querySelectorAll('.nav-current > a').forEach(function (link) {
        link.setAttribute('aria-current', 'page');
    });

    const logo = document.querySelector('.gh-head-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = 0.03 * (index + 1) + 's';
        });
    }

    var windowClickListener;
    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                return;
            }
        }

        if (!submenuItems.length) {
            document.body.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle');
        toggle.setAttribute('aria-label', '更多');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            document.body.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = 'repeat(' + Math.ceil(submenuItems.length / 2) + ', 1fr)';
        } else {
            document.body.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        document.body.classList.add('is-dropdown-loaded');

        toggle.addEventListener('click', function () {
            document.body.classList.toggle('is-dropdown-open');
        });

        windowClickListener = function (e) {
            if (!toggle.contains(e.target) && document.body.classList.contains('is-dropdown-open')) {
                document.body.classList.remove('is-dropdown-open');
            }
        };
        window.addEventListener('click', windowClickListener);
    }

    imagesLoaded(head, function () {
        makeDropdown();
    });

    window.addEventListener('resize', function () {
        setTimeout(function () {
            window.removeEventListener('click', windowClickListener);
            nav.innerHTML = navHTML;
            makeDropdown();
        }, 1);
    });
})();
